<template>
	<div class="back-ssl">
		<div class="back-ssl__glow"></div>
		<div class="back-ssl__grain"></div>

		<div class="back-ssl__content">
			<div class="seal">
				<span class="seal__halo"></span>
				<svg class="seal__icon" viewBox="0 0 88 88" aria-hidden="true">
					<circle class="seal__disc" cx="44" cy="44" r="32" />
					<circle class="seal__ring" cx="44" cy="44" r="41" />
					<path class="seal__check" d="M28 45 L38.5 55.5 L60 33" />
				</svg>
			</div>

			<h1 class="back-ssl__title">{{ title }}</h1>
			<p class="back-ssl__desc">{{ desc }}</p>

			<div class="summary">
				<div class="summary__row">
					<span class="summary__label">完成时间</span>
					<span class="summary__value">{{ finishTime }}</span>
				</div>
				<p class="summary__tip" v-if="tip">{{ tip }}</p>
			</div>
		</div>

		<BaseFooter class="back-ssl__footer">
			<van-button
				class="back-ssl__btn"
				type="primary"
				block
				round
				@click="clickBack"
			>返 回</van-button>
		</BaseFooter>
	</div>
</template>

<script>
export default {
	name: 'BackSsl',
	data: () => ({
		loading: false,
		finishTime: ''
	}),
	computed: {
		title () {
			return this.$route.query.title || '操作完成'
		},
		desc () {
			return this.$route.query.desc || '您的操作已成功提交，可返回继续其他操作'
		},
		tip () {
			return this.$route.query.tip || ''
		},
		delta () {
			return Number(this.$route.query.delta) || 1
		}
	},
	created () {
		this.finishTime = this.$moment().format('YYYY-MM-DD HH:mm')
		if (this.$route.query.title) document.title = this.$route.query.title
	},
	methods: {
		clickBack () {
			if (this.loading) return
			this.loading = true

			const wx = window.wx
			try {
				if (wx && typeof wx.navigateBack === 'function') {
					// 小程序页面栈内直接返回上一页
					wx.navigateBack({ delta: this.delta })
				} else if (wx && wx.miniProgram && typeof wx.miniProgram.navigateBack === 'function') {
					// web-view 内嵌场景
					wx.miniProgram.navigateBack({ delta: this.delta })
				} else if (window.history.length > 1) {
					this.$router.back()
				} else {
					this.$router.replace('/')
				}
			} catch (e) {
				this.$router.back()
			}

			// 兜底：接口未生效时放开按钮，避免卡死
			setTimeout(() => { this.loading = false }, 1000)
		}
	}
}
</script>

<style scoped lang="less">
.back-ssl {
	position: relative;
	min-height: 100vh;
	box-sizing: border-box;
	overflow: hidden;
	background-color: #fff;

	&__glow {
		position: absolute;
		top: -190px;
		left: 50%;
		width: 440px;
		height: 440px;
		margin-left: -220px;
		border-radius: 50%;
		pointer-events: none;
		background: radial-gradient(circle at 50% 50%, var(--color-primary-light) 0%, rgba(255, 255, 255, 0) 70%);
		animation: glow-breathe 7s ease-in-out infinite;
	}

	&__grain {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		opacity: 0.035;
		pointer-events: none;
		background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='120' height='120' filter='url(%23n)'/%3E%3C/svg%3E");
	}

	&__content {
		position: relative;
		padding: 108px 24px 0;
		text-align: center;
	}

	&__title {
		margin: 0;
		padding-top: 28px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-size: 22px;
		font-weight: 600;
		line-height: 1.3;
		letter-spacing: 1px;
		color: #1f2329;
		animation: rise 0.5s 0.12s cubic-bezier(0.22, 1, 0.36, 1) both;
	}

	&__desc {
		margin: 0;
		padding: 10px 16px 0;
		font-family: PingFang SC;
		font-size: 14px;
		line-height: 22px;
		color: #8f959e;
		animation: rise 0.5s 0.2s cubic-bezier(0.22, 1, 0.36, 1) both;
	}

	&__footer {
		::v-deep .base-footer-main.fixed {
			padding-bottom: calc(20px + constant(safe-area-inset-bottom));
			padding-bottom: calc(20px + env(safe-area-inset-bottom));
		}
	}

	&__btn {
		height: 48px;
		::v-deep .van-button__text {
			font-family: PingFangSC-Semibold, PingFang SC;
			font-size: 17px;
			font-weight: 600;
			letter-spacing: 2px;
			color: #1f2329;
		}
	}
}

.seal {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 88px;
	height: 88px;
	margin: 0 auto;
	animation: seal-pop 0.62s cubic-bezier(0.34, 1.56, 0.64, 1) both;

	&__halo {
		position: absolute;
		top: -16px;
		right: -16px;
		bottom: -16px;
		left: -16px;
		border-radius: 50%;
		background-color: var(--color-primary-light);
		filter: blur(8px);
		animation: halo-pulse 3.4s ease-in-out infinite;
	}

	&__icon {
		position: relative;
		width: 88px;
		height: 88px;
	}

	&__disc {
		fill: var(--color-primary);
	}

	&__ring {
		fill: none;
		stroke: var(--color-primary);
		stroke-width: 1.5;
		stroke-dasharray: 2 7;
		opacity: 0.45;
		transform-origin: 44px 44px;
		animation: ring-spin 14s linear infinite;
	}

	&__check {
		fill: none;
		stroke: #fff;
		stroke-width: 5.5;
		stroke-linecap: round;
		stroke-linejoin: round;
		stroke-dasharray: 60;
		stroke-dashoffset: 60;
		animation: draw-check 0.5s 0.3s cubic-bezier(0.65, 0, 0.35, 1) forwards;
	}
}

.summary {
	margin-top: 36px;
	padding: 14px 16px;
	text-align: left;
	border-radius: 14px;
	background-color: #f8f9fb;
	animation: rise 0.5s 0.3s cubic-bezier(0.22, 1, 0.36, 1) both;

	&__row {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	&__label {
		font-family: PingFang SC;
		font-size: 13px;
		color: #8f959e;
	}

	&__value {
		font-family: PingFangSC-Semibold, PingFang SC;
		font-size: 14px;
		font-weight: 500;
		color: #1f2329;
	}

	&__tip {
		margin: 12px 0 0;
		padding-top: 12px;
		font-family: PingFang SC;
		font-size: 13px;
		line-height: 20px;
		color: #8f959e;
		border-top: 1px solid #eff0f1;
	}
}

@keyframes seal-pop {
	0% {
		opacity: 0;
		transform: scale(0.4);
	}
	60% {
		opacity: 1;
		transform: scale(1.06);
	}
	100% {
		opacity: 1;
		transform: scale(1);
	}
}

@keyframes draw-check {
	to {
		stroke-dashoffset: 0;
	}
}

@keyframes rise {
	from {
		opacity: 0;
		transform: translateY(12px);
	}
	to {
		opacity: 1;
		transform: none;
	}
}

@keyframes halo-pulse {
	0%,
	100% {
		opacity: 0.9;
		transform: scale(1);
	}
	50% {
		opacity: 0.45;
		transform: scale(1.1);
	}
}

@keyframes glow-breathe {
	0%,
	100% {
		opacity: 0.85;
		transform: scale(1);
	}
	50% {
		opacity: 1;
		transform: scale(1.06);
	}
}

@keyframes ring-spin {
	to {
		transform: rotate(360deg);
	}
}
</style>
